<template>
  <page-section
    :section-name="name"
    :content="textContent"
    wrapper-class="py-6"
    v-slot="{ content }"
  >
    <h3 class="mb-6">{{ content.title }}</h3>
    <p class="text-blue">{{ content.body[0] }}</p>
    <h4>{{ content.regions.title }}</h4>
    <ul class="regions py-6 font-sans">
      <li class="pt-3">
        <strong class="uppercase">{{ content.regions.americas.title }}</strong>
        <br />
        {{ content.regions.americas.regions }}
      </li>
      <li class="pt-3">
        <strong class="uppercase">{{ content.regions.africa.title }}</strong>
        <br />
        {{ content.regions.africa.regions }}
      </li>
      <li class="pt-3">
        <strong class="uppercase">{{ content.regions.asia.title }}</strong>
        <br />
        {{ content.regions.asia.regions }}
      </li>
    </ul>
    <div class="information pt-10 font-sans">
      <div class="map relative flex items-center justify-center">
        <img
          src="../assets/images/Photos/Highlighting_issues_for_election_2019/map_splash_image.png"
          role="presentation"
        />
        <img
          src="../assets/images/Photos/Highlighting_issues_for_election_2019/map_nobackground-w-pins.png"
          class="absolute"
          role="presentation"
        />
      </div>
      <fade-shift ratio="0.1" class="map-tile map-tile-1">
        <div class="heading">
          <img :src="images[0]" role="presentation" />
          <p class="h4">{{ content.tiles[0].title }}</p>
        </div>
        <p>{{ content.tiles[0].body }}</p>
      </fade-shift>
      <fade-shift ratio="0.5" class="map-tile map-tile-2">
        <div class="heading">
          <img :src="images[1]" role="presentation" />
          <p class="h4">{{ content.tiles[1].title }}</p>
        </div>
        <p>{{ content.tiles[1].body }}</p>
      </fade-shift>
      <fade-shift ratio="0.9" class="map-tile map-tile-3">
        <div class="heading">
          <img :src="images[2]" role="presentation" />
          <p class="h4">{{ content.tiles[2].title }}</p>
        </div>
        <p>{{ content.tiles[2].body }}</p>
      </fade-shift>
      <fade-shift ratio="0.1" class="map-tile map-tile-4">
        <div class="heading">
          <img :src="images[3]" role="presentation" />
          <p class="h4">{{ content.tiles[3].title }}</p>
        </div>
        <p>{{ content.tiles[3].body }}</p>
      </fade-shift>
      <fade-shift ratio="0.5" class="map-tile map-tile-5">
        <div class="heading">
          <img :src="images[4]" role="presentation" />
          <p class="h4">{{ content.tiles[4].title }}</p>
        </div>
        <p>{{ content.tiles[4].body }}</p>
      </fade-shift>
      <fade-shift ration="0.9" class="map-tile map-tile-6">
        <div class="heading">
          <img :src="images[5]" role="presentation" />
          <p class="h4">{{ content.tiles[5].title }}</p>
        </div>
        <p>{{ content.tiles[5].body }}</p>
      </fade-shift>
      <fade-shift ration="0.9" class="map-tile map-tile-7">
        <div class="heading">
          <img :src="images[6]" role="presentation" />
          <p class="h4">{{ content.tiles[6].title }}</p>
        </div>
        <p>{{ content.tiles[6].body }}</p>
      </fade-shift>
    </div>
  </page-section>
</template>

<script>
export default {
  name: "globalizingEqualityIn2019",
  components: {
    pageSection: () => import("@/components/PageSection.vue"),
    fadeShift: () => import("@/components/FadeShift.vue"),
  },
  data() {
    return {
      name: "globalizingEqualityIn2019",
      images: [
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/map1.png"),
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/map2.png"),
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/map3.png"),
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/map4.png"),
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/map5.png"),
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/map6.png"),
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/map7.png"),
      ],
    };
  },
  computed: {
    textContent() {
      const { name } = this;

      return this.$t(`i18nSections.${name}`);
    },
  },
};
</script>

<style lang="scss">
#page-globalizingEqualityIn2019 {
  .information {
    display: grid;
    grid-template-areas:
      "tile1"
      "tile2"
      "tile3"
      "map"
      "tile4"
      "tile5"
      "tile6"
      "tile7";
    grid-template-columns: auto;
    grid-template-rows: repeat(8, auto);
    gap: 2rem;

    @screen xl {
      grid-template-areas:
        "tile1 tile2 tile3"
        "map map map"
        "tile4 tile5 tile6"
        ". tile7 .";
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(4, auto);
    }

    .map {
      grid-area: map;
      align-self: center;
    }

    @for $i from 1 through 7 {
      .map-tile-#{$i} {
        grid-area: tile#{$i};
      }
    }

    .map-tile > .heading {
      display: grid;
      grid-template-columns: 6rem auto;
      grid-template-rows: 1fr;
      gap: 0.5rem;

      @screen lg {
        grid-template-columns: 4rem auto;
      }

      p {
        align-self: flex-end;
      }
    }
  }
}
</style>
